import { Loader } from '@googlemaps/js-api-loader'

export default {
  data() {
    return {
      gMapLoader: null,
      mapConfig: {
        disableDefaultUI: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        zoomControl: true,
        draggable: true,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        keyboardShortcuts: false,
      },
      map: null,
      infoWindow: null,
    }
  },
  methods: {
    initMap() {
      this.gMapLoader = new Loader({
        apiKey: this.$config.googleMapsApiKey,
        version: 'weekly',
      })
    },
    toggleInfoWindow: function (marker, data, afterOpen = null) {
      marker.addEventListener('gmp-click', () => {
        this.infoWindow.close()
        this.infoWindow.setContent(data)
        this.infoWindow.open({ map: this.map, anchor: marker })
        if (typeof afterOpen === 'function') afterOpen()
      })
    },
  },
}
